<template>
    <detail-form
        v-model="ticketVisibilityForm">
        <template v-slot:content="{ form }">
            <template v-if="isUpdate">
                <detail-form-item
                    disabled
                    cols="6"
                    type="text"
                    v-model="form.createdAt"
                    :label="$t('ticketVisibility.details.createdDate')"/>
                <detail-form-item
                    disabled
                    cols="6"
                    type="text"
                    v-model="form.updatedAt"
                    :label="$t('ticketVisibility.details.latestChangedDate')"/>
            </template>

            <detail-form-item
                cols="6"
                type="select"
                v-model="form.type"
                :label="$t('ticketVisibility.details.type')"
                :items="['Standard', 'Promotion', 'FlexiMobile'].map(v => {
                    return { value: v, text: v }
                })"/>

            <detail-form-item
                required
                cols="6"
                type="select"
                v-model="form.visibilityType"
                :items="['recurring-daily', 'one-time', 'always'].map(v => {
                    return {
                        text: $t(`ticketVisibility.visibilityType.${v}`),
                        value: v
                    }
                })"
                :label="$t('ticketVisibility.details.visibilityType')"/>
            <detail-form-item
                v-if="dateSelectType !== null"
                disabled
                cols="12"
                v-model="form.date"
                :type="dateSelectType"
                :label="$t('ticketVisibility.details.date')"/>
        </template>
    </detail-form>
</template>

<script>
import DetailForm from '@/components/forms/DetailForm'
import DetailFormItem from '@/components/forms/DetailFormItem'

export default {
    name: 'TicketVisibilityDetailsView',

    model: {
        prop: 'ticketVisibility',
        event: 'input'
    },

    props: {
        ticketVisibility: {
            type: Object,
            default: () => {}
        },

        isUpdate: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            dateSelectType: null
        }
    },

    watch: {
        ticketVisibilityForm: {
            handler (newValue) {
                switch (newValue.visibilityType) {
                    case 'recurring-daily':
                        this.dateSelectType = 'timeRange'
                        break
                    case 'one-time':
                        this.dateSelectType = 'dateTimeRange'
                        break
                    default:
                        this.dateSelectType = null
                        break
                }
            },
            deep: true
        }
    },

    components: {
        DetailForm,
        DetailFormItem
    },

    computed: {
        ticketVisibilityForm: {
            get () {
                return this.ticketVisibility
            },

            set (value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        async save () {
            await this.$store.dispatch('ticketVisibility/updateTicketVisibility', this.ticketVisibilityForm)
            await this.$store.dispatch('ticketVisibility/fetchTicketsVisibility')
        },

        async create () {
            await this.$store.dispatch('ticketVisibility/createTicketVisibility', this.ticketVisibilityForm)
            await this.$store.dispatch('ticketVisibility/fetchTicketsVisibility')
        },

        async delete () {
            await this.$store.dispatch('ticketVisibility/deleteTicketVisiblity', this.ticketVisibilityForm.id)
            await this.$store.dispatch('ticketVisibility/fetchTicketsVisibility')
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
